import CityPageTemplate from "../city-template/CityPageTemplate";
import { rentonConfig } from "./data";

export default function RentonPage() {
  return <CityPageTemplate config={rentonConfig} />;
}